(function () {
  'use strict';

  var ATC = {
    cfg: {
      button: 'form.js-product-form-quickshop .js-ajax-submit.add-item',
      productJson: '.product-json',
      formVariant: '#formVariantId',
      priceTestData: '#product-price script.price-test-data, .price-test-data',
      label: 'ADD TO BAG',
      preorder: 'PRE-ORDER',
      soldOut: 'SOLD OUT',
      cls: {
        base: 'atc-redesigned', inner: 'atc-redesigned__inner', label: 'atc-redesigned__label',
        price: 'atc-redesigned__price', compare: 'atc-redesigned__compare', preorder: 'atc-redesigned--preorder'
      }
    },
    el: null, product: null, testData: {},

    init: function () {
      this.el = document.querySelector(this.cfg.button);
      if (!this.el) return;
      this.product = this.json(this.cfg.productJson);
      if (!this.product || !this.product.variants) return;

      var ptd = this.json(this.cfg.priceTestData);
      this.testData = (ptd && ptd.variants) ? ptd.variants : {};
      this.el.classList.add(this.cfg.cls.base);

      var self = this;
      this.render(this.currentVariant()); // first paint from logic

      // _activePriceVariation is assigned shortly after load — re-render when known
      this.retry(function () { return !!window._activePriceVariation; }, function () {
        self.render(self.currentVariant());
      });

      // stay in sync via the theme's global event bus
      this.retry(function () { return window.Events && typeof window.Events.on === 'function'; }, function () {
        window.Events.on('variantinputchange', function (v) { self.render(v); });
      });
    },

    json: function (sel) {
      var el = document.querySelector(sel);
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    },

    retry: function (cond, cb, n) {
      n = n || 0;
      if (cond() || n >= 25) { cb(); return; }
      var self = this;
      setTimeout(function () { self.retry(cond, cb, n + 1); }, 100);
    },

    currentVariant: function () {
      var idEl = document.querySelector(this.cfg.formVariant);
      var id = idEl ? parseInt(idEl.value, 10) : null;
      var v = id && this.product.variants.find(function (x) { return x.id === id; });
      return v || this.product.variants.find(function (x) { return x.available; }) || this.product.variants[0] || null;
    },

    variation: function () {
      if (window._activePriceVariation === 'price-test-variation-1') return '1';
      if (window._activePriceVariation === 'price-test-variation-2') return '2';
      return 'control';
    },

    _fmt: undefined,

    getMoneyFormat: function () {
      if (this._fmt !== undefined) return this._fmt;
      this._fmt = '';
      var form = this.el ? this.el.closest('form') : null;
      if (form && form.dataset.productForm) {
        try {
          var cfg = JSON.parse(form.dataset.productForm);
          if (cfg && cfg.money_format) this._fmt = cfg.money_format;
        } catch (e) {}
      }
      return this._fmt;
    },

    money: function (c) {
      if (c == null || isNaN(c)) return '';
      if (window.WAU && WAU.Helpers && typeof WAU.Helpers.formatMoney === 'function') {
        var fmt = this.getMoneyFormat();
        var out = fmt ? WAU.Helpers.formatMoney(c, fmt) : WAU.Helpers.formatMoney(c);
        return out.replace(/[.,]00(?=\s|$)/, ''); // mirror Liquid's money_without_trailing_zeros
      }
      // fallback only if the helper isn't on the page
      var d = c / 100;
      return d.toFixed(c % 100 === 0 ? 0 : 2);
    },

    prices: function (v) {
      var t = this.testData[v.id] || {}, w = this.variation(), price, compare;
      if (w === '1') {
        price = t.price_1 != null ? t.price_1 : v.price;
        compare = t.compare_at_price_1 != null ? t.compare_at_price_1 : v.compare_at_price;
      } else if (w === '2') {
        price = t.price_2 != null ? t.price_2 : v.price;
        compare = t.compare_at_price_2 != null ? t.compare_at_price_2 : v.compare_at_price;
      } else {
        price = v.price; compare = v.compare_at_price;
      }
      return { current: this.money(price), compare: (compare && compare > price) ? this.money(compare) : '' };
    },

    isPreOrder: function (v) {
      return !!v && v.available && v.inventory_management != null && v.inventory_quantity <= 0;
    },

    render: function (v) {
      if (!this.el || !v) return;
      var cls = this.cfg.cls;
      this.el.classList.toggle(cls.preorder, this.isPreOrder(v));
      this.el.disabled = !v.available;

      if (!v.available) {
        this.el.innerHTML = '<span class="' + cls.inner + '"><span class="' + cls.label + '">' + this.cfg.soldOut + '</span></span>';
        return;
      }
      var p = this.prices(v);
      var label = this.isPreOrder(v) ? this.cfg.preorder : this.cfg.label;
      var cmp = p.compare ? '<span class="' + cls.compare + '">' + p.compare + '</span>' : '';
      this.el.innerHTML =
        '<span class="' + cls.inner + '">' +
          '<span class="' + cls.label + '">' + label + ' -' +
            '<span class="' + cls.price + '">' + p.current + '</span>' +
          '</span>' + cmp +
        '</span>';
    }
  };

  window.AtcButtonRedesign = ATC;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ATC.init(); });
  } else { ATC.init(); }
})();